import React from 'react';

export const NotFound = props => {
  return <div>Not-Found</div>;
};
